import { z } from "zod";

export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 20;

export const UsernameSchema = z
  .string({ required_error: "El nombre de usuario es obligatorio" })
  .min(USERNAME_MIN_LENGTH, {
    message: "El nombre de usuario es demasiado corto",
  })
  .max(USERNAME_MAX_LENGTH, {
    message: "El nombre de usuario es demasiado largo",
  })
  .regex(/^[a-zA-Z0-9_]+$/, {
    message:
      "El nombre de usuario solo puede incluir letras, números y guiones bajos",
  })
  // users can type the username in any case, but we store it in lowercase
  .transform((value) => value.toLowerCase());

export const PasswordSchema = z
  .string({ required_error: "La contraseña es obligatoria" })
  .min(6, { message: "La contraseña es demasiado corta" })
  .max(100, { message: "La contraseña es demasiado larga" });

export const NameSchema = z
  .string({ required_error: "El nombre es obligatorio" })
  .min(3, { message: "El nombre es demasiado corto" })
  .max(40, { message: "El nombre es demasiado largo" });

export const EmailSchema = z
  .string({ required_error: "El correo electrónico es obligatorio" })
  .email({ message: "El correo electrónico no es válido" })
  .min(3, { message: "El correo electrónico es demasiado corto" })
  .max(100, { message: "El correo electrónico es demasiado largo" })
  // users can type the email in any case, but we store it in lowercase
  .transform((value) => value.toLowerCase());

export const PasswordAndConfirmPasswordSchema = z
  .object({ password: PasswordSchema, confirmPassword: PasswordSchema })
  .superRefine(({ confirmPassword, password }, ctx) => {
    if (confirmPassword !== password) {
      ctx.addIssue({
        path: ["confirmPassword"],
        code: "custom",
        message: "Las contraseñas deben coincidir",
      });
    }
  });
